import { cloneDeep } from 'lodash'
import { Referral } from '@/api/model/referral'
import { unparse } from 'papaparse'
import i18n from '@/i18n'
import { date as formatDate, datetime as formatDateTime } from '@/plugins/filters-date'

export const exportExcel = async (referrals: Referral[]) => {
    const csvData = cloneDeep<Referral[]>(referrals).map(entry => ({
        pipeline: entry.pipeline ? entry.pipeline.name : null,
        phase: entry.phase ? entry.phase.name : null,
        priority: entry.priority,
        status: i18n.t(`referral.phaseModelStatus.${entry.status}`),
        statusReason: entry.newStatusReason ? entry.newStatusReason.name : null,
        newBuildType: entry.newBuildType ? i18n.t(`new_build_type.${entry.newBuildType}`) : null,
        futureStreetname: entry.futureStreetname,
        futureStreetnumber: entry.futureStreetnumber,
        futureStreetnumbersuffix: entry.futureStreetnumbersuffix,
        futureZipcode: entry.futureZipcode,
        futureCity: entry.futureCity,
        futureCountry: entry.futureCountry,
        futureLatitude: entry.futureLatitude,
        futureLongitude: entry.futureLongitude,
        futureFrom: entry.futureFrom ? formatDate(entry.futureFrom) : null,
        project: entry.project ? entry.project.name : null,
        buildNumber: entry.buildNumber,
        assigneeProject: entry.assigneeProject ? entry.assigneeProject.name : null,
        assigneeBuildNumber: entry.assigneeBuildNumber,
        orderValue: entry.orderValue,
        leadCommission: entry.leadCommission,
        channel: i18n.t(`referral.channel.${entry.channel}`),
        source: entry.newSource ? entry.newSource.name : null,
        transportDate: entry.transportDate ? formatDate(entry.transportDate) : null,
        productionDate: entry.productionDate ? formatDate(entry.productionDate) : null,
        score: entry.score,
        createdAt: formatDateTime(entry.createdAt),
        updatedAt: formatDateTime(entry.updatedAt),

        contact_source: entry.contact ? entry.contact.newSource?.name : null,
        contact_gender: entry.contact && entry.contact.gender ? i18n.t(`gender.${entry.contact.gender}`) : null,
        contact_firstname: entry.contact ? entry.contact.firstname : null,
        contact_middlename: entry.contact ? entry.contact.middlename : null,
        contact_lastname: entry.contact ? entry.contact.lastname : null,
        contact_streetname: entry.contact ? entry.contact.streetname : null,
        contact_streetnumber: entry.contact ? entry.contact.streetnumber : null,
        contact_streetnumbersuffix: entry.contact ? entry.contact.streetnumbersuffix : null,
        contact_zipcode: entry.contact ? entry.contact.zipcode : null,
        contact_city: entry.contact ? entry.contact.city : null,
        contact_country: entry.contact ? entry.contact.country : null,
        contact_email: entry.contact ? entry.contact.email : null,
        contact_mobilePhonenumber: entry.contact ? entry.contact.mobilePhonenumber : null,
        contact_phonenumber: entry.contact ? entry.contact.phonenumber : null,
        contact_spouseGender: entry.contact && entry.contact.spouseGender ? i18n.t(`gender.${entry.contact.spouseGender}`) : null,
        contact_spouseFirstname: entry.contact ? entry.contact.spouseFirstname : null,
        contact_spouseMiddlename: entry.contact ? entry.contact.spouseMiddlename : null,
        contact_spouseLastname: entry.contact ? entry.contact.spouseLastname : null,
        contact_createdAt: entry.contact ? formatDateTime(entry.contact.createdAt) : null,
        contact_updatedAt: entry.contact ? formatDateTime(entry.contact.updatedAt) : null,

        referredBy_firstname: entry.referredBy ? entry.referredBy.firstname : null,
        referredBy_middlename: entry.referredBy ? entry.referredBy.middlename : null,
        referredBy_lastname: entry.referredBy ? entry.referredBy.lastname : null,
        referredBy_email: entry.referredBy ? entry.referredBy.email : null,
        referredBy_role: entry.referredBy && entry.referredBy.role ? i18n.t(`role.${entry.referredBy.role}`) : null,
        referredBy_gender: entry.referredBy && entry.referredBy.gender ? i18n.t(`gender.${entry.referredBy.gender}`) : null,

        assignedTo_firstname: entry.assignedTo ? entry.assignedTo.firstname : null,
        assignedTo_middlename: entry.assignedTo ? entry.assignedTo.middlename : null,
        assignedTo_lastname: entry.assignedTo ? entry.assignedTo.lastname : null,
        assignedTo_email: entry.assignedTo ? entry.assignedTo.email : null,
        assignedTo_role: entry.assignedTo && entry.assignedTo.role ? i18n.t(`role.${entry.assignedTo.role}`) : null,
        assignedTo_gender: entry.assignedTo && entry.assignedTo.gender ? i18n.t(`gender.${entry.assignedTo.gender}`) : null,

        assignedToBranch_name: entry.assignedToBranch.name ? entry.assignedToBranch.name : null,
        assignedToBranch_streetname: entry.assignedToBranch.streetname ? entry.assignedToBranch.streetname : null,
        assignedToBranch_streetnumber: entry.assignedToBranch.streetnumber ? entry.assignedToBranch.streetnumber : null,
        assignedToBranch_suffix: entry.assignedToBranch.suffix ? entry.assignedToBranch.suffix : null,
        assignedToBranch_zipcode: entry.assignedToBranch.zipcode ? entry.assignedToBranch.zipcode : null,
        assignedToBranch_city: entry.assignedToBranch.city ? entry.assignedToBranch.city : null,
        assignedToBranch_country: entry.assignedToBranch.country ? entry.assignedToBranch.country : null,
        assignedToBranch_phonenumber: entry.assignedToBranch.phonenumber ? entry.assignedToBranch.phonenumber : null,
        assignedToBranch_email: entry.assignedToBranch.email ? entry.assignedToBranch.email : null,
        assignedToBranch_website: entry.assignedToBranch.website ? entry.assignedToBranch.website : null,
        assignedToBranch_logo: entry.assignedToBranch.logo ? entry.assignedToBranch.logo : null,
        assignedToBranch_primaryColor: entry.assignedToBranch.primaryColor ? entry.assignedToBranch.primaryColor : null,
        assignedToBranch_createdAt: entry.assignedToBranch.createdAt ? formatDateTime(entry.assignedToBranch.createdAt) : null,
        assignedToBranch_updatedAt: entry.assignedToBranch.updatedAt ? formatDateTime(entry.assignedToBranch.updatedAt) : null,

        appointment: entry.appointment,
        appointmentLocation: entry.appointmentLocation,
    }))

    // @todo: determine actual seperator
    const csv = `sep=,\n${unparse(csvData)}`
    const url = URL.createObjectURL(new Blob([csv], {
        type: 'text/csv;charset=utf-8',
    }))

    const dummyElement = document.createElement('a')
    dummyElement.href = url
    dummyElement.setAttribute('download', 'export.csv')
    dummyElement.click()
}
